import { render } from "./sys_config.vue?vue&type=template&id=4c25aa24"
import script from "./sys_config.vue?vue&type=script&lang=js"
export * from "./sys_config.vue?vue&type=script&lang=js"

import "./sys_config.vue?vue&type=style&index=0&id=4c25aa24&lang=css"
script.render = render

export default script